import React from 'react';
import styles from './WizardVideoThumbnail.module.scss';

interface Props {
	thumbnailUrl: string;
	onClick: () => void;
}

const WizardVideoThumbnail: React.FC<Props> = ({ thumbnailUrl, onClick }) => {
	return (
		<div className={styles.wrapper}>
			<img className={styles.thumbnail} src={thumbnailUrl} />
			<img
				className={styles.playButton}
				src='/dist/patientV3/icons/wizard-play-button.svg'
				alt='wizard play button'
				onClick={onClick}
			/>
		</div>
	);
};

export default WizardVideoThumbnail;
